export default __webpack_public_path__ + "static/media/browser (2).8e8ca733.svg";